<template >
  <div class="sub-page">
    <van-nav-bar
        title="修改用户资料"
        left-text="返回"
        left-arrow
        @click-left="$router.back()"
        id="topbar"
    />

    <van-form class="sub-page__form" @submit="onSubmit">
      <div class="sub-page__body">
        <div class="topDiv">
          <van-cell-group>
            <van-field name="avatar" label="头像" input-align="right">
              <template #input>
                <img class="headImg" :src="apiUrl + 'download/' + userInfo.avatar"/>
                <van-uploader v-model="avatar" :max-count="1" :before-delete="beforeDel" :before-read="beforeRead" :after-read="afterRead" />
              </template>
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field label="姓名" required v-model="userInfo.nname" maxlength="50" input-align="right" :rules="[{ required: true, message: '请输入姓名'}]"/>
          </van-cell-group>
          <van-cell-group>
            <van-field name="radio" required label="性别" input-align="right" :rules="[{ required: true, message: '请选择性别'}]">
              <template #input>
                <van-radio-group v-model="userInfo.ssex" direction="horizontal">
                  <van-radio name="0">男</van-radio>
                  <van-radio name="1">女</van-radio>
                  <van-radio name="2">保密</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field label="邮箱" required v-model="userInfo.email" input-align="right" :rules="[{ required: true, message: '请输入邮箱'}]"/>
          </van-cell-group>
        </div>
      </div>

      <div class="sub-page__footer">
        <van-button block color="#1B75F6" native-type="submit">完成提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
    import Vue from 'vue';
    import $ from '@/fly'
    import { Toast, Uploader, Dialog } from 'vant';
    import uploadfilecommon from '@/libs/uploadfilecommon';
    import Setting from '@/setting';

    Vue.use(Uploader);
    export default {
        name: 'common-modifyUserInfo',
        data () {
            return {
                userInfo: {},
                avatar: [],
                apiUrl: Setting.apiBaseURL
            }
        },

        methods: {
            onSubmit () {
                $.put('user/updatePerson', this.userInfo).then(res => {
                    Toast.success('修改成功！');
                    this.$store.state.admin.user.info.nname = this.userInfo.nname;
                    this.$store.state.admin.user.info.ssex = this.userInfo.ssex;
                    this.$store.state.admin.user.info.email = this.userInfo.email;
                    this.$store.state.admin.user.info.avatar = this.userInfo.avatar;
                    localStorage.setItem('USER', JSON.stringify(this.$store.state.admin.user.info));
                    this.$router.back();
                }).catch(err => {
                    Toast.fail(err.message);
                })
            },
            timestampToTime (timestamp) {
                var date = new Date(timestamp); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                const Y = date.getFullYear() + '-';
                const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                const D = date.getDate() + ' ';
                const h = date.getHours() + ':';
                const m = date.getMinutes() + ':';
                const s = date.getSeconds();
                return Y + M + D + h + m + s;
            },
            beforeRead (file) {
                if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
                    Toast('只允许上传jpg/png格式的图片！')
                    return false;
                }
                return true
            },
            async afterRead (file) {
                // 此时可以自行将文件上传至服务器
                file.status = 'uploading';
                file.message = '上传中...';
                const fid = await uploadfilecommon(file.file, 'AVATAR')
                file.status = 'done';
                file.message = '上传成功';
                if (fid && fid.length === 32) {
                    this.userInfo.avatar = fid;
                    this.$store.state.admin.user.info.avatar = this.userInfo.avatar;
                }
            },
            beforeDel (file, detail) {
                Dialog.confirm({
                    title: '是否删除头像'
                }).then(() => {
                    $.delete('deleteFile/' + this.userInfo.avatar).then(res => {
                        this.userInfo.avatar = '';
                        this.avatar.splice(detail.index, 1);
                        $.put('user', this.userInfo);
                        Toast.success('删除成功！');
                        return true;
                    }).catch(err => {
                        Toast.fail(err.message);
                        return false;
                    });
                })
            }
        },
        mounted () {
            $.get('user/' + this.$store.state.admin.user.info.username).then(res => {
                this.userInfo = res;
                this.userInfo.createTime = this.timestampToTime(this.userInfo.createTime);
                this.userInfo.modifyTime = this.timestampToTime(this.userInfo.modifyTime);
                this.userInfo.lastLoginTime = this.timestampToTime(this.userInfo.lastLoginTime);
                if (this.userInfo.avatar) {
                    this.avatar[0] = { url: this.apiUrl + 'download/' + this.userInfo.avatar, isImage: true };
                }
            })
        }
    }
</script>

<style lang="less" scoped>
    /* 导航 + 表单 + 底部按钮三段式，替代「screen.height + position:fixed」 */
    .sub-page {
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        background-color: #F7F7F7;
    }

    .sub-page__form {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }

    .sub-page__body {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
    }

    .sub-page__footer {
        flex-shrink: 0;
        padding-bottom: env(safe-area-inset-bottom);
    }

    .topDiv {
        margin-top: 20px;
    }

    .headImg {
        width: 160px;
        height: 160px;
        display: none;
    }
</style>
